import * as ENDPOINTS from '@/common/constants/endpoints'
import { shouldInsertAccount } from '@/utils/account'

import { api } from '../api'

export const getOverdraftDetails = async ({
  account,
  appType,
}: DefaultHeader): Promise<OverdraftDetails | undefined> =>
  api(ENDPOINTS.OVERDRAFT_DETAILS, {
    method: 'GET',
    headers: {
      ...shouldInsertAccount({ appType, account }),
    },
  })
